var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-component',{ref:"tableComponent",attrs:{"model":_vm.model,"show-form":false,"url-create-form":"/loan-request","url-edit-form":"/accounts/edit","force-paginate":"","permissions":_vm.permissions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }